import { createFileRoute } from "@tanstack/react-router";
import { DistributionsAdmin } from "@/components/Distributions/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;
  return <DistributionsAdmin id={id} />;
}

export const Route = createFileRoute("/_authenticated/distributions/$id/")({
  component: RouteComponent,
  staticData: { page: ["distributions", "deals"] },
});
